<template>
	<div class="swiper-button-next swiper-test-button-next">
	  <i class="fa-thin fa-angle-right fa-2x"></i>
	</div>
	<div class="swiper-button-prev swiper-test-button-prev">
	  <i class="fa-thin fa-angle-left fa-2x"></i>
	</div>
</template>